import React from 'react';
import { motion } from 'framer-motion';
export function HeroText() {
  return <div className="text-center max-w-4xl mx-auto px-4" data-id="element-196">
      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.2,
      ease: 'easeOut'
    }} className="text-5xl md:text-6xl font-bold text-gray-900 tracking-tight mb-6 leading-[1.1]" data-id="element-197">
        Crea campañas que{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-gray-700" data-id="element-198">
          cautiven
        </span>
      </motion.h1>

      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.4,
      ease: 'easeOut'
    }} className="text-xl md:text-1xl text-gray-600 font-normal max-w-2xl mx-auto leading-relaxed" data-id="element-199">
        Genera tus propias estrategias y pautas publicitarias usando Danke Hub IA.
      </motion.p>
    </div>;
}